/**
 * @fileoverview Agent definition for the plot-synopsis-merge-v3 primitive.
 *
 * This agent merges multiple sequential chunk synopses into a single
 * coherent synopsis. It is the "reduce" step in the map-reduce synopsis
 * pipeline for epic-length documents.
 *
 * This is an editing/stitching task — it removes overlap redundancy,
 * smooths transitions, and ensures consistency, but does NOT further
 * compress the content.
 *
 * @category import.story.synopsis.merge
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-synopsis-merge-v3',
  kind: 'primitive',
  name: 'Synopsis Merge',
  description: 'Merges multiple sequential chunk synopses into a single coherent synopsis. The reduce step in the map-reduce synopsis pipeline.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'import.story.synopsis.merge',
    usedBy: ['use-plot-synopsis-extractor-v3.ts', 'use-long-form-import.ts'],
    relatedAgents: ['plot-synopsis-extractor-v3', 'plot-synopsis-extractor-chunked-v3'],
  },
};
